var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIcCloseinline = function SvgIcCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.167.167a.571.571 0 01.808 0l22.858 22.858a.571.571 0 11-.808.808L.166.975a.571.571 0 010-.808z",
    fill: "#121E6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.833.167a.571.571 0 00-.808 0L.166 23.025a.571.571 0 10.808.808L23.833.975a.571.571 0 000-.808z",
    fill: "#121E6C"
  })));
};
export default SvgIcCloseinline;